import { useMemo, useState } from "react";
import { Alert } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  useCreateTypeMutation,
  useGetAllTypes,
} from "../../../../../api/jeep-rally/types/types.hooks";
import { isJeepRallyAdmin } from "../../Categories/utils/category.utils";
import TypeForm from "../_components/TypeForm";
import {
  buildTypeFormData,
  getTypeApiErrorMessage,
  initialTypeForm,
  normalizeTypes,
  validateTypeForm,
} from "../utils/type.utils";

const TypeCreatePage = () => {
  const history = useHistory();
  const canManage = isJeepRallyAdmin();
  const [form, setForm] = useState(initialTypeForm);
  const [validationErrors, setValidationErrors] = useState({});

  const { data: typesData } = useGetAllTypes();
  const types = useMemo(() => normalizeTypes(typesData), [typesData]);

  const {
    mutate: createType,
    isLoading,
    isPending,
    error,
    reset,
  } = useCreateTypeMutation();

  const submitting = isLoading || isPending;

  const updateField = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
    setValidationErrors((prev) => ({ ...prev, [key]: undefined }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canManage) return;
    reset();

    const nextErrors = validateTypeForm(form, { existingTypes: types });
    setValidationErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    createType(buildTypeFormData(form, { isEdit: false }), {
      onSuccess: () => {
        history.push("/jeep-rally/types");
      },
    });
  };

  const goBack = () => history.push("/jeep-rally/types");

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={goBack}
              aria-label="Back to types list"
              title="Back"
            >
              <i className="bi bi-arrow-left fs-4" />
            </button>
            <h4 className="card-title mb-0">Create Type</h4>
          </div>
        </div>

        <div className="card-body">
          <p className="text-muted mb-4">
            Create a type. The unique key is generated by the backend from the
            name.
          </p>

          {!canManage && (
            <Alert variant="warning" className="mb-4">
              Admin access is required to create types.
            </Alert>
          )}

          {error && (
            <Alert variant="danger" className="mb-4">
              {getTypeApiErrorMessage(
                error,
                "Failed to create type. Please try again."
              )}
            </Alert>
          )}

          <TypeForm
            form={form}
            validationErrors={validationErrors}
            submitting={submitting}
            submitLabel="Create Type"
            submittingLabel="Creating..."
            readOnly={!canManage}
            onSubmit={handleSubmit}
            onFieldChange={updateField}
            onBack={goBack}
          />
        </div>
      </div>
    </div>
  );
};

export default TypeCreatePage;
